import request from '@/utils/request';

// 根据字典类型获取字典列表 type
export function getDictsType(options) {
  return request({
    url: '/dicts/list?type=' + options,
    method: 'get'
  });
}

// 获取反馈列表 feedbackType pageNum pageSize
export function getFeedBackInfos(options) {
  return request({
    url: '/feedbackinfos/page-list',
    method: 'get',
    params: options
  });
}
// 批量修改反馈状态
export function getFeedBackStatus(options) {
  return request({
    url: '/feedbackinfos/batch-status',
    method: 'post',
    data: options
  });
}
